"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioList = void 0;
const react_1 = __importStar(require("react"));
const radio_1 = require("../radio");
require("./styles.scss");
const RadioList = (props) => {
    const { label, options = [], error, warning, orientation = "vertical", onChange, disabled, name, selectedValue, } = props;
    const [selected, setSelected] = (0, react_1.useState)(selectedValue);
    (0, react_1.useEffect)(() => {
        setSelected(selectedValue);
    }, [selectedValue]);
    return (react_1.default.createElement("div", { className: `c-radio-list c-radio-list--${orientation}` },
        label && react_1.default.createElement("div", { className: "c-radio-list__label" }, label),
        react_1.default.createElement("div", { className: "c-radio-list__list" }, options.map((option, index) => (react_1.default.createElement("div", { className: "c-radio-list__list-item", key: option.value + index },
            react_1.default.createElement(radio_1.Radio, { name: name, disabled: disabled, onChange: (checked) => {
                    checked && setSelected(option.value);
                    onChange === null || onChange === void 0 ? void 0 : onChange(option.value);
                }, label: option.label, checked: option.value === selected }))))),
        error && react_1.default.createElement("div", { className: "c-radio-list__validation" }, error),
        warning && react_1.default.createElement("div", { className: "c-radio-list__warning" }, warning)));
};
exports.RadioList = RadioList;
